<template>
  <div>
    <div
      class="table-panel flex flex-between item-center bgColor"
      style="padding: 0 10px"
    >
      <div>
        <el-button type="primary" class="mr10" size="small" @click="addGoods"
          >新建商品</el-button
        >
      </div>

      <div class="flex item-center shop-list">
        <div class="flex">
          <el-select
            size="small"
            clearable
            placeholder="上架状态"
            v-model="searchCondition.salesState"
            class="mr10"
            filterable
          >
            <el-option label="上架" value="up"></el-option>
            <el-option label="下架" value="down"></el-option>
          </el-select>
          <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.brandId"
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.brandId"
              v-for="(v, i) in allBrandList.records"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.spuType"
            placeholder="请选择商品类型"
          >
            <el-option label="实物" value="reality"></el-option>
            <el-option label="虚拟" value="virtual"></el-option>
          </el-select>
          <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.overstockSales"
            placeholder="请选择是否开启预售"
          >
            <el-option label="已开启" value="open"></el-option>
            <el-option label="未开启" value="close"></el-option>
          </el-select>
          <!-- <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.spuMainPic"
            placeholder="请选择是否有主图"
          >
            <el-option label="有主图" value="yes"></el-option>
            <el-option label="无主图" value="no"></el-option>
          </el-select> -->
          <el-input
            clearable
            style="width: 300px"
            v-model.trim="searchCondition.keyWords"
            size="small"
            :placeholder="placeholder"
            class="ipt mr10"
          >
            <el-select
              slot="prepend"
              size="small"
              style="width: 100px"
              @change="selectQueryType"
              v-model="searchCondition.queryType"
            >
              <el-option label="商品名" value="spu_name"></el-option>
              <el-option label="货号" value="goods_sn"></el-option>
              <el-option label="条码" value="spec_barcode"></el-option>
            </el-select>
          </el-input>
        </div>

        <div class="flex item-center mr10 pointer ml10" @click="drawer = true">
          <div class="more-search">更多筛选</div>
          <div>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button type="info" size="small" @click="searchCondition = {}"
          >重置</el-button
        >
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出全部明细</el-button
        >

        <!-- <el-cascader
        v-model="searchCondition.categoryId"
        :show-all-levels="false"
        size="small"
        class="mr10 flex-1"
        :props="categoryFuncs"
        clearable
        placeholder="请选择类目"
      ></el-cascader>

      <el-cascader
        v-model="searchCondition.wxshopCategoryId"
        :show-all-levels="false"
        size="small"
        class="mr10 flex-1"
        :props="categoryProp"
        clearable
        placeholder="请选择微店商品分类"
      ></el-cascader> -->
      </div>
    </div>
    <hm-content title="商品列表" class="micro-goods-list" :hidden="hidden">
      <!-- <div class="flex flex-start mb20" v-if="false">
        <el-cascader
          v-model="searchCondition.attributeId"
          placeholder="请选择辅助属性"
          :show-all-levels="false"
          size="small"
          class="mr10"
          :props="attributeFunc"
          clearable
        ></el-cascader>
        <el-select
          size="small"
          clearable
          placeholder="上架状态"
          v-model="searchCondition.salesState"
          class="mr10"
          filterable
        >
          <el-option label="上架" value="up"></el-option>
          <el-option label="下架" value="down"></el-option>
        </el-select>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.minPrice"
          placeholder="最低零售价"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 100px"
          v-model.trim="searchCondition.maxPrice"
          placeholder="最高零售价"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-date-picker
          v-model="searchCondition.applyDate"
          type="datetimerange"
          align="right"
          start-placeholder="请选择创建时间段"
          end-placeholder="请选择创建时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          class=" mr10 time"
        ></el-date-picker>
        <el-select
          size="small"
          v-model="searchCondition.expressId"
          filterable
          class="mr10"
          clearable
          placeholder="请选择运费模板"
        >
          <el-option
            :label="v.expressName"
            :value="v.expressId"
            v-for="(v, i) in expressList"
            :key="i"
          ></el-option>
        </el-select>
      </div> -->
      <!-- </div> -->
      <div class="table">
        <div class="flex flex-between mb10">
          <div>
            <span>已选{{ num }}条</span>
            <el-button
            type="success"
            size="small"
            style="margin-left:10px;"
            @click="priceVerification"
            :loading="isOutputing"
            ><i class="el-icon-document el-icon--left"></i>生成价格校验结果</el-button
        >
          </div>
          <div class="flex item-center">
            <!-- <el-button type="text" size="mini" @click="outputExcel" class="">
              <span class="hmicon icon-daochu"></span>
              批量设置模板导出</el-button
            > -->
            <div @click="openRuleForm" class="pointer mr10">
              <span class="hmicon icon-xitong"></span>
              微店商品设置
            </div>
            <div
              @click="(openDownLoad) => (downloadVisible = true)"
              class="pointer mr10"
            >
              <span class="hmicon icon-daochu"></span>
              下载模板
            </div>
            <div
              @click="(openExport) => (exportVisible = true)"
              class="pointer mr10"
            >
              <span class="hmicon icon-daoru"></span>
              导入
            </div>
            <!-- <div @click="outputExcelChangePrice" class="pointer mr10">
              <span class="hmicon icon-daochu"></span>
              批量修改商品价格模板导出
            </div>
            <div class="pointer mr10 open-file">
              <span class="hmicon icon-daoru"></span>
              批量修改商品价格导入
              <input
                type="file"
                @change="importfChangePrice"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
            <div @click="outputExcel" class="pointer mr10">
              <span class="hmicon icon-daochu"></span>
              模板导出
            </div>
            <div class="pointer mr10 open-file">
              <span class="hmicon icon-daoru"></span>
              商品导入
              <input
                type="file"
                @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div> -->

            <!-- <el-button class="mr10 open-file" type="primary" size="mini"
              >批量设置商品导入
              <input
                type="file"
                @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </el-button> -->
            <div @click="batchSetting" class="pointer mr10">
              <span class="delete-icon hmicon icon-xitong"></span>
              批量设置
            </div>
            <div @click="wxAudit" class="pointer mr10">
              <span class="delete-icon hmicon icon-xitong"></span>
              批量提交微信审核
            </div>
          </div>

          <!-- <div @click="batchDelete">
          <span class="delete-icon hmicon icon-shanchu"></span>删除
        </div> -->
        </div>
        <el-table
          stripe
          border
          ref="brandTable"
          @sort-change="sortChange"
          @selection-change="getChecked"
          :data="microShopGoodsList.records"
          style="width: 100%"
          id="table"
          max-height="650px"
          size="small"
          :default-sort="{ prop: 'num', order: 'descending' }"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品名称"
            width="180px"
          >
            <template slot-scope="scope">
              <div @dblclick="changeEnddate(scope.$index, scope.row)">
                <span v-show="scope.row.edit_enddate">{{
                  scope.row.wxshopSpuName
                }}</span>
                <el-input
                  :ref="'enddateinput' + scope.$index"
                  @blur="enddateblur(scope.$index, scope.row)"
                  @keyup.enter.native="$event.target.blur"
                  clearable
                  v-show="!scope.row.edit_enddate"
                  size="mini"
                  style="width: 100%"
                  v-model="scope.row.wxshopSpuName"
                  placeholder="请输入内容"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSnAndBarcode"
            show-overflow-tooltip
            label="商品编码/条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          ></el-table-column>
          <!-- <el-table-column
          header-align="center"
          align="center"
          prop="isOverseas"
          label="是否海外商品"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.isOverseas === 'yes'">
              是
            </div>
            <div v-else>
              否
            </div>
          </template>
        </el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="spuType"
            label="商品类型"
          >
            <template slot-scope="scope">
              <el-tag type="warning"
                >{{
                  scope.row.spuType === "virtual" ? "虚拟" : "实物"
                }}商品</el-tag
              >
              <!-- <span v-show="scope.row.spuType === 'reality'">实物</span>
            <span v-show="scope.row.spuType === 'virtual'">虚拟</span> -->
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="couponUsable"
            label="是否允许使用优惠券"
          >
            <template slot-scope="scope">
              <span v-show="scope.row.couponUsable === 'yes'" class="success"
                >开启</span
              >
              <span v-show="scope.row.couponUsable === 'no'" class="gray"
                >禁止</span
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="overstockSales"
            label="是否开启预售"
          >
            <template slot-scope="scope">
              <span v-show="scope.row.overstockSales === 'open'">已开启</span>
              <span v-show="scope.row.overstockSales === 'close'">未开启</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuMainPic"
            label="是否有主图"
            width="120px"
          >
            <template slot-scope="scope">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.spuMainPic"
                :preview-src-list="[scope.row.spuMainPic]"
                v-if="scope.row.spuMainPic"
              >
              </el-image>
              <span v-else>无主图</span>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="可售门店"
          >
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.shopName" placement="left">
                <span class="text-overflow">{{ scope.row.shopName }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="commissionState"
            label="佣金状态"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.commissionState ? "是" : "否" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="isOverseas"
            label="是否海外商品"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.isOverseas === 'yes'">是</span>
                <span v-else>否</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realSalesNum"
            label="销量"
            sortable
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="supplierName"
            label="供货商"
          >
            <template slot-scope="scope">
              {{
                scope.row.supplierName === null
                  ? "自营"
                  : scope.row.supplierName
              }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
            sortable
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="salesState"
            label="上架状态"
          >
            <template slot-scope="scope">
              <span class="status danger" v-show="scope.row.salesState === 0"
                >下架</span
              >
              <span class="status success" v-show="scope.row.salesState === 1"
                >上架</span
              >
            </template>
          </el-table-column>
          <el-table-column header-align="center" align="center" label="库存">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewStock(scope.row)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="280"
            header-align="center"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="edit(scope.row)"
                  >编辑</el-button
                >

                <!-- <el-tooltip class="item" content="编辑" placement="top">
                  <div class="pointer mr10" @click="edit(scope.row)">
                    <span class="hmicon icon-bianji blue"></span>
                  </div>
                </el-tooltip> -->

                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="memberPrice(scope.row)"
                  >会员价</el-button
                >
                <!-- <el-tooltip class="item" content="会员价" placement="top">
                  <div class="pointer mr10" @click="memberPrice(scope.row)">
                    <span class="hmicon icon-jiage primary"></span>
                  </div>
                </el-tooltip> -->

                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="productQrcode(scope.row)"
                  >商品二维码</el-button
                >
                <el-button
                  type="text"
                  class="gray"
                  size="small"
                  @click="hide(scope.row)"
                  >隐藏</el-button
                >
                <el-button
                  type="text"
                  class="danger"
                  size="small"
                  @click="del(scope.row)"
                  >删除</el-button
                >
                <!-- <el-tooltip class="item" content="商品二维码" placement="top">
                  <div
                    class="pointer mr10"
                    @click="productQrcode(scope.row.wxshopSpuId)"
                  >
                    <span class="hmicon icon-erweima primary"></span>
                  </div>
                </el-tooltip> -->

                <!-- <el-tooltip class="item" content="复制商品链接" placement="top">
                  <div
                    class="pointer mr10"
                    @click="copy(scope.row.wxshopSpuId)"
                  >
                    <span class="hmicon icon-fuzhi primary"></span>
                  </div>
                </el-tooltip> -->

                <!-- <el-tooltip class="item" content="删除" placement="top">
                  <div class="pointer mr10" @click="del(scope.row)">
                    <span class="hmicon icon-shanchu primary"></span>
                  </div>
                </el-tooltip> -->

                <!-- <el-tooltip class="item" content="隐藏" placement="top">
                  <div class="pointer mr10" @click="hide(scope.row)">
                    <span class="hmicon icon-yincang gray"></span>
                  </div>
                </el-tooltip> -->

                <!-- <el-tooltip
                  class="item"
                  v-if="scope.row.salesState === 1"
                  content="提交微信审核"
                  placement="top"
                >
                  <div class="pointer mr10" @click="wxAudit(scope.row)">
                    <span class="primary hmicon icon-tijiaoweixinshenhe"></span>
                  </div>
                </el-tooltip> -->
              </div>
              <div class="flex flex-center item-center">
                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="statistical(scope.row)"
                  >统计</el-button
                >
                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  @click="copy(scope.row.wxshopSpuId)"
                  >复制商品链接</el-button
                >

                <el-button
                  type="text"
                  class="blue"
                  size="small"
                  v-if="scope.row.salesState === 1"
                  @click="wxAudit(scope.row)"
                  >提交微信审核</el-button
                >

                <el-button
                  type="text"
                  size="small"
                  @click="editSpuShareState(scope.row)"
                >
                  <span class="success" v-if="scope.row.shareState === 'yes'"
                    >分享开启</span
                  >
                  <span class="danger" v-else>分享禁用</span>
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="microShopGoodsList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
      <el-drawer :visible.sync="dialogVisible" direction="rtl" size="700px">
        <!-- <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
    > -->
        <div slot="title">
          <span class="mr10">批量设置</span>
          <span class="form-item-tip"
            >已选商品数量{{ checkedRow.length }}个</span
          >
        </div>
        <div class="flex tabs">
          <el-form
            label-width="100px"
            ref="ruleForm"
            :rules="rules"
            :model="batchCondition"
          >
            <el-tabs tab-position="left" v-model="tabType">
              <el-tab-pane label="商品名称" name="goodsName">
                <div v-if="tabType === 'goodsName'">
                  <div class="first-tip">
                    <div class="title">替换名称</div>
                    <span class="form-item-tip"
                      >将商品名称中的文字替换成其他文字，“替换为”内容为空时，则将原有文字删除</span
                    >
                  </div>
                  <el-form-item label="原有文字" prop="oldWord">
                    <el-input
                      size="small"
                      type="text"
                      v-model="batchCondition.oldWord"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="替换为" prop="newWord">
                    <el-input
                      size="small"
                      type="text"
                      v-model="batchCondition.newWord"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-tab-pane>
              <el-tab-pane label="商品分类" name="wxshopCategoryId">
                <el-radio-group
                  v-model="batchCondition.categoryOperationType"
                  @change="setCategoryOperator"
                >
                  <el-radio label="edit"> 修改 </el-radio>
                  <el-radio label="create"> 新增 </el-radio>
                </el-radio-group>

                <el-form-item
                  :label="categoryOperatorLabelName"
                  prop="wxshopCategoryId"
                  v-if="tabType === 'wxshopCategoryId'"
                >
                  <el-cascader
                    v-model="batchCondition.categoryRelModelList"
                    :show-all-levels="false"
                    size="small"
                    class="mr10"
                    :props="categoryFunc"
                    clearable
                    placeholder="请选择微店商品分类"
                  ></el-cascader>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="可售门店" name="shopModelList">
                <el-form-item
                  label="可销售门店"
                  prop="shopModelList"
                  v-if="tabType === 'shopModelList'"
                >
                  <el-select
                    clearable
                    multiple
                    v-model="batchCondition.shopModelList"
                    @change="getCheckedStore"
                    placeholder="请选择可销售门店"
                    size="small"
                    filterable
                    class="mr10"
                  >
                    <el-option
                      label="全部门店"
                      :disabled="selectOther"
                      value="all"
                    ></el-option>
                    <el-option
                      :label="v.shopName"
                      :value="v.shopId"
                      :disabled="selectAll"
                      v-for="(v, i) in microShopStoreList"
                      :key="i"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="配送方式" name="express">
                <el-form-item
                  label="配送方式"
                  prop="deliveryMode"
                  v-if="tabType === 'express'"
                >
                  <el-checkbox-group
                    v-model="batchCondition.deliveryMode"
                    @change="deliveryModeChange"
                  >
                    <el-checkbox
                      v-for="(v, i) in salesChannels"
                      :label="v.value"
                      :key="i"
                      >{{ v.name }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item
                  label="运费模板"
                  prop="expressId"
                  v-if="tabType === 'express' && expressFlag"
                >
                  <el-select
                    size="small"
                    v-model="batchCondition.expressId"
                    filterable
                    class="ml10"
                    clearable
                    placeholder="请选择运费模板"
                  >
                    <el-option
                      :label="v.expressName"
                      :value="v.expressId"
                      v-for="(v, i) in expressList"
                      :key="i"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="销售上架" name="salesStartTime">
                <div v-if="tabType === 'salesStartTime'">
                  <el-form-item label="开售时间" prop="salesStartTime">
                    <el-date-picker
                      v-model="batchCondition.salesStartTime"
                      type="datetime"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      placeholder="请选择开售时间"
                      size="small"
                      class="mr10"
                    ></el-date-picker>
                    <div class="form-item-tip">
                      开售商品必须先上架，需商品在指定时间下，才能开售，否则上架状态下，显示开售倒计时
                    </div>
                  </el-form-item>
                  <el-form-item label="上架时间" prop="upStartTime">
                    <el-date-picker
                      v-model="batchCondition.upStartTime"
                      type="datetime"
                      placeholder="请选择上架时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      size="small"
                      class="mr10"
                    ></el-date-picker>
                    <div class="form-item-tip">上架后商品才可销售</div>
                  </el-form-item>
                  <el-form-item label="下架时间" prop="downStartTime">
                    <el-date-picker
                      v-model="batchCondition.downStartTime"
                      type="datetime"
                      placeholder="请选择下架时间"
                      align="right"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      size="small"
                      class="mr10"
                    ></el-date-picker>
                  </el-form-item>
                </div>
              </el-tab-pane>
              <el-tab-pane label="商品限购" name="eachMemberPurchaseLimit">
                <el-form-item
                  label="每人限购"
                  prop="eachMemberPurchaseLimit"
                  v-if="tabType === 'eachMemberPurchaseLimit'"
                >
                  <el-input
                    clearable
                    v-model.trim="batchCondition.eachMemberPurchaseLimit"
                    placeholder
                    size="small"
                    class="ipt"
                  ></el-input>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="商品属性" name="spuType">
                <el-form-item
                  label="商品类型"
                  prop="spuType"
                  v-if="tabType === 'spuType'"
                >
                  <el-radio-group v-model="batchCondition.spuType">
                    <el-radio label="reality">
                      实物商品
                      <span class="form-item-tip">需要发货</span>
                    </el-radio>
                    <el-radio label="virtual">
                      虚拟商品
                      <span class="form-item-tip">无需发货</span>
                    </el-radio>
                  </el-radio-group>
                  <div class="form-item-tip">商品类型一旦选择，不可更改</div>
                  <div v-if="batchCondition.spuType === 'virtual'">
                    <div class="flex item-center">
                      <span class="mr10">虚拟商品售后</span>
                      <el-radio-group
                        v-model="batchCondition.memberLaunchRefund"
                      >
                        <el-radio label="no">不支持买家申请退款</el-radio>
                        <el-radio label="yes">支持买家申请退款</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="form-item-tip">
                      商品详情页将展示“不支持申请退款的说明”，买家只能主动联系商家处理
                    </div>
                  </div>
                </el-form-item>
                <el-form-item label="商品净重">
                  <el-input
                    v-model.trim="batchCondition.netWeight"
                    @input="filterGt0OrFixed2('netWeight')"
                    class="mr10"
                    size="small"
                    type="number"
                    style="width: 80px"
                  ></el-input>
                  <el-select
                    style="width: 100px"
                    size="small"
                    class="auto-width-select"
                    v-model="batchCondition.weightUnit"
                    placeholder="请选择商品净重"
                  >
                    <el-option label="克" value="g"></el-option>
                    <el-option label="千克" value="kg"></el-option>
                  </el-select>
                  <div class="form-item-tip">
                    商品重量应用到计算与重量相关的配送方式计价
                  </div>
                </el-form-item>

                <!-- <el-form-item label="每人限购">
                <el-input
                  clearable
                  v-model.trim="searchCondition.eachMemberPurchaseLimit"
                  placeholder
                  size="small"
                  class="ipt"
                ></el-input>
              </el-form-item> -->
              </el-tab-pane>
              <el-tab-pane label="商品预购" name="overstockSalesMode">
                <el-form-item
                  label="商品预购："
                  v-if="tabType === 'overstockSalesMode'"
                  prop="overstockSalesMode"
                  class="is-required"
                >
                  <el-switch
                    v-model="batchCondition.overstockSales"
                    active-text="开启"
                    inactive-text="关闭"
                    active-color="#13ce66"
                    active-value="open"
                    inactive-value="close"
                  ></el-switch>
                  <div class="form-item-tip">
                    预购关闭，则库存按照实际库存出；预购开启则商品按照预购库存出
                  </div>
                  <div
                    class="flex item-center"
                    v-if="batchCondition.overstockSales === 'open'"
                  >
                    <span class="mr10">预购开启</span>
                    <el-radio-group v-model="batchCondition.overstockSalesMode">
                      <el-radio label="date">
                        <el-date-picker
                          :disabled="
                            batchCondition.overstockSalesMode !== 'date'
                          "
                          v-model="batchCondition.deliveryDeadline"
                          type="datetime"
                          align="right"
                          value-format="yyyy-MM-dd HH:mm:ss"
                          placeholder="请选择开售时间"
                          size="small"
                          class="mr10"
                        ></el-date-picker
                        >前发货
                      </el-radio>
                      <el-radio label="day">
                        付款成功
                        <el-input
                          :disabled="
                            batchCondition.overstockSalesMode !== 'day'
                          "
                          size="small"
                          clearable
                          style="width: 80px"
                          class="mr10 ipt"
                          @input="filterGt0('afterPayDays')"
                          maxlength="2"
                          v-model.trim="batchCondition.afterPayDays"
                        ></el-input
                        >天后发货
                      </el-radio>
                    </el-radio-group>
                  </div>
                  <div
                    class="form-item-tip primary"
                    v-if="batchCondition.overstockSales === 'open'"
                  >
                    注意：只允许设置1-90天内发货，请务必按照约定时间发货，以免引起客户投诉
                  </div>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane label="会员价" name="memberPrices">
                <!-- <el-form-item label="设置会员价" prop="memberPrices"> -->
                <div v-if="tabType === 'memberPrices'">
                  <el-radio-group v-model="batchCondition.priceType">
                    <el-radio label="discount"> 设置折扣 </el-radio>
                    <el-radio label="money"> 设置价格 </el-radio>
                  </el-radio-group>

                  <div>
                    <el-table
                      stripe
                      :data="memberGroupList"
                      style="width: 100%"
                      id="table"
                      size="small"
                      max-height="400"
                    >
                      <el-table-column
                        type="index"
                        label="序号"
                        width="50"
                      ></el-table-column>
                      <el-table-column
                        header-align="center"
                        align="center"
                        prop="groupAppellation"
                        label="群组名称"
                      ></el-table-column>
                      <el-table-column
                        width="300"
                        header-align="center"
                        align="center"
                        prop="value"
                        :label="
                          batchCondition.spuType === 'discount'
                            ? '折扣'
                            : '会员价'
                        "
                      >
                        <template slot-scope="scope">
                          <el-input
                            clearable
                            style="width: 100px"
                            v-model="scope.row.value"
                            size="small"
                            @input="filterGroupFixed2(scope.$index, 'value')"
                            class="ipt mr10"
                          ></el-input
                          >{{
                            batchCondition.priceType == "money" ? "元" : "折"
                          }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <!-- </el-form-item> -->
              </el-tab-pane>
              <!-- <el-tab-pane label="运费模板" name="express">
                <el-select
                  v-if="tabType === 'express'"
                  size="small"
                  v-model="batchCondition.expressId"
                  filterable
                  class="ml10"
                  clearable
                  placeholder="请选择运费模板"
                >
                  <el-option
                    :label="v.expressName"
                    :value="v.expressId"
                    v-for="(v, i) in expressList"
                    :key="i"
                  ></el-option>
                </el-select>
              </el-tab-pane> -->
              <el-tab-pane label="商品回收站" name="recycleState">
                <el-radio-group v-model="batchCondition.recycleState">
                  <el-radio label="hide"> 隐藏 </el-radio>
                  <el-radio label="yes"> 删除 </el-radio>
                </el-radio-group>
              </el-tab-pane>
              <el-tab-pane label="是否允许用券" name="couponUsable">
                <el-radio-group v-model="batchCondition.couponUsable">
                  <el-radio label="yes"> 允许用券 </el-radio>
                  <el-radio label="no"> 不允许用券 </el-radio>
                </el-radio-group>
              </el-tab-pane>
              <el-tab-pane label="是否允许分享" name="shareState">
                <el-radio-group v-model="batchCondition.shareState">
                  <el-radio label="yes"> 允许分享 </el-radio>
                  <el-radio label="no"> 不允许分享 </el-radio>
                </el-radio-group>
              </el-tab-pane>
              <el-tab-pane label="可售库存" name="stockNum">
                <div class="tips">{{ tips }}</div>
                <el-form-item
                  label="可售库存"
                  prop="stockNum"
                  v-if="tabType === 'stockNum'"
                >
                  <el-input
                    clearable
                    v-model.trim="batchCondition.stockNum"
                    placeholder
                    size="small"
                    class="ipt"
                  ></el-input>
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </el-form>
        </div>
        <div class="dialog-footer flex flex-center mt10">
          <el-button @click="submitRuleForm" size="small" type="primary"
            >保存</el-button
          >
          <el-button @click="dialogVisible = false" size="small" type="primary"
            >关闭</el-button
          >
        </div>
      </el-drawer>
      <!-- </el-dialog> -->

      <el-dialog
        title="修改会员价"
        :close-on-click-modal="false"
        :visible.sync="dialogVisiblePrice"
        width="80%"
      >
        <div>
          <el-radio v-model="priceType" label="money">设置价格</el-radio>
          <el-radio v-model="priceType" label="discount">设置折扣</el-radio>
        </div>

        <!-- <div class="table ">
        <div class="table-header flex">
          <div
            class="flex-1 flex-center"
            v-for="(v, i) in ruleForm.skuModelListCopy"
            :key="i"
          >
            {{ v.specName }}
          </div>

          <div
            class="flex-1 flex-center"
            v-for="(v, i) in group"
            :key="i + 'a'"
          >
            {{ v.groupAppellation }}
          </div>
        </div>

        <div
          class="flex table-row item-center "
          v-for="(v, i) in ruleForm.skuModelList"
          :key="i + 'b'"
        >
          <div
            v-for="(o, i) in v.specValueList"
            :key="i + 'x'"
            class="flex-1 text-center"
          >
            <div class="flex-1 text-center">
              {{ v["specValue" + i] }}
            </div>
          </div>

          <div class="flex-1 text-center">{{ v.wxshopPrice }}</div>
          <div
            class="flex-1 flex flex-center"
            v-for="(x, i) in v.groupList"
            :key="i + 'c'"
          >
            <div class="el-input el-input el-input--small" style="width:50px">
              <input
                class="el-input__inner"
                size="small"
                style="width:80px;"
                v-model="
                  x[
                    v.skuId
                      ? `${v.skuId}&&&${x.groupId}`
                      : `${ruleForm.skuId}&&&${x.groupId}`
                  ]
                "
              />
            </div>
          </div>
        </div>
      </div> -->
        <div class="table flex flex-wrap">
          <div class="table-header">
            <div
              class="flex flex-center member-price"
              v-for="(v, i) in ruleForm.skuModelListCopy"
              :key="i"
            >
              {{ v.specName }}
            </div>

            <div
              class="flex flex-center member-price"
              v-for="(v, i) in group"
              :key="i + 'a'"
            >
              {{ v.groupAppellation }}
            </div>
            <!-- <div class="flex-1 text-center">可售库存</div>
          <div class="flex-1 text-center">操作</div> -->
          </div>
          <div
            class="table-row item-center member-price"
            v-for="(v, i) in ruleForm.skuModelList"
            :key="i + 'b'"
          >
            <div
              v-for="(o, i) in v.specValueList"
              :key="i + 'x'"
              class="flex-1 text-center"
            >
              <div class="flex-1 text-center">
                {{ v["specValue" + i] }}
              </div>
            </div>

            <div class="flex-1 text-center">{{ v.wxshopPrice }}</div>
            <div
              class="flex-1 flex flex-center"
              v-for="(x, i) in v.groupList"
              :key="i + 'c'"
            >
              <div
                class="el-input el-input el-input--small"
                style="width: 80px"
              >
                <input
                  class="el-input__inner"
                  size="small"
                  style="width: 80px"
                  v-model="
                    x[
                      v.skuId
                        ? `${v.skuId}&&&${x.groupId}`
                        : `${ruleForm.skuId}&&&${x.groupId}`
                    ]
                  "
                />
              </div>
              {{ priceType == "money" ? "元" : "折" }}
            </div>
          </div>
        </div>
        <div style="margintop: 30px">
          <span style="marginright: 20px">批量设置</span>
          <el-select
            clearable
            class="mr10"
            size="small"
            v-model="groupType"
            placeholder="请选择群组"
          >
            <el-option
              v-for="(item, i) in group"
              :key="i"
              :label="item.groupAppellation"
              :value="i"
            ></el-option>
          </el-select>
          <el-input
            type="number"
            clearable
            style="width: 100px"
            v-model="batchPrice"
            size="small"
            @input="filterGt0OrFixed2()"
            class="ipt mr10"
          ></el-input
          >{{ priceType == "money" ? "元" : "折" }}
        </div>
        <div class="flex flex-center" style="margintop: 30px">
          <el-button type="primary" size="small" @click="affirm"
            >提交</el-button
          >
          <el-button size="small" @click="dialogVisiblePrice = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <el-dialog
        title="查看库存"
        :close-on-click-modal="false"
        :visible.sync="stockDialogVisible"
      >
        <el-table
          stripe
          border
          class="mb20"
          ref="brandTable"
          @selection-change="getChecked"
          :data="stockList"
          style="width: 100%"
          id="table"
          size="small"
          max-height="400"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="sku名称"
          >
            <template slot-scope="scope">
              <div>
                <span>{{ scope.row.spuName }}</span>
                <span v-if="scope.row.specIdGroupName">{{
                  scope.row.specIdGroupName
                }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="skuSpecName"
            show-overflow-tooltip
            label="商品规格"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="skuBarcode"
            show-overflow-tooltip
            label="商品条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="depotName"
            show-overflow-tooltip
            label="仓库名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="stockQty"
            label="剩余库存"
          >
            <!-- <template slot-scope="scope" v-if="scope.row.depotId">
            <el-input
              size="small"
              @blur="changeRowStock(scope.row)"
              @input="filterInteger(scope.$index, scope.row.stockQty)"
              v-model="scope.row.stockQty"
            ></el-input>
          </template> -->
          </el-table-column>
        </el-table>
        <div class="flex flex-center">
          <el-button size="small" @click="stockDialogVisible = false"
            >取消</el-button
          >
        </div>
      </el-dialog>
      <hm-import-temp
        :tHeader="tHeader"
        :tBody="tBody"
        @close="importTempVisible = false"
        title="商品导入"
        filterText="spuName"
        :visible="importTempVisible"
      ></hm-import-temp>
      <el-dialog
        title="请用微信扫一扫"
        :visible.sync="qrcodeDialogVisible"
        :modal="false"
        width="250px"
      >
        <div class="qrcode-wrapper">
          <img :src="activityCode" alt="二维码" />
        </div>
      </el-dialog>
      <el-dialog
        title="提交微信审核"
        :close-on-click-modal="false"
        :visible.sync="wxAuditDialogVisible"
        width="1000px"
      >
        <div v-if="wechatAuditInfo" class="mb10">
          <span v-if="wechatAuditInfo.status" style="margin-right: 20px">
            <label>商品线上状态:</label>{{ wechatAuditInfo.status }}
          </span>
          <span style="margin-right: 120px">
            <label>商品草稿状态:</label>{{ wechatAuditInfo.edit_status }}
          </span>
          <span
            v-if="wechatAuditInfo.reject_reason"
            style="color: red; margin-right: 20px"
          >
            <label>审核不通过原因:</label>{{ wechatAuditInfo.reject_reason }}
          </span>
          <span
            v-if="wechatAuditInfo.errMsg"
            style="color: red; margin-right: 20px"
          >
            <label>错误信息:</label>{{ wechatAuditInfo.errMsg }}
          </span>
        </div>
        <div class="mb10">
          <el-button @click="showAuditCat" size="small" type="primary"
            >查看审核通过的类目</el-button
          >
        </div>
        <div style="line-height: 20px">
          此功能仅限针对视频号自定义组件，请先确认相关组件已经
          申请获得，按照微信及相关法律法规要求，请您选择商品符合的行业类目并提交审核!
        </div>
        <div class="danger mb10" style="line-height: 20px">
          注意:部分类目需要相关资质审核，具体审核信息请在小程序后台完成
        </div>

        <el-form
          :model="wxAuditruleForm"
          :rules="wxAuditRules"
          ref="wxAuditruleForm"
          label-width="120px"
        >
          <el-form-item label="产品行业类目" prop="thirdRelationId">
            <el-cascader
              v-if="wxAuditDialogVisible"
              :show-all-levels="false"
              :options="options"
              @change="optionsChange"
              filterable
              v-model="wxAuditruleForm.thirdRelationId"
              size="small"
              :props="{ label: 'cat_name', value: 'all', children: 'childs' }"
              clearable
            >
            </el-cascader>

            <!-- <el-select
          clearable
          size="small"
          style="width:360px"
          v-model="wxAuditruleForm.thirdRelationId"
          placeholder="请选择产品行业类目"
          filterable
        >
          <el-option
            v-for="(v,i) in codeInfoModelList"
            :key="i"
            :label="v.thirdInterfaceName"
            :value="v.thirdRelationId"
          >
          </el-option>
        </el-select> -->
          </el-form-item>
          <el-form-item
            label="上传营业执照"
            prop="license"
            v-if="showUploadImg"
          >
            <el-upload
              class="upload flex"
              ref="license"
              drag
              multiple
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadMainPicSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading('license')"
              :show-file-list="uploadShow"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
            <div class="flex flex-wrap">
              <div
                class="priview"
                v-show="v"
                v-for="(v, i) in wxAuditruleForm.license"
                :key="i"
              >
                <el-image
                  style="height: 100%"
                  :src="v"
                  :preview-src-list="wxAuditruleForm.spuSlideShowPicList"
                ></el-image>
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="handleRemove(i)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </el-form-item>
          <div
            class="danger mb10"
            v-if="
              (showUploadImg || product_qualification_type) &&
              wxAuditruleForm.product_qualification
            "
          >
            {{ wxAuditruleForm.product_qualification }}
          </div>
          <el-form-item
            label="上传食品经营许可证"
            prop="certificate"
            v-if="showUploadImg || product_qualification_type"
          >
            <el-upload
              class="upload flex"
              ref="certificate"
              drag
              multiple
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadCertificateSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading('certificate')"
              :show-file-list="certificateShow"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
            <div class="flex flex-wrap">
              <div
                class="priview"
                v-show="v"
                v-for="(v, i) in wxAuditruleForm.certificate"
                :key="i"
              >
                <el-image
                  style="height: 100%"
                  :src="v"
                  :preview-src-list="wxAuditruleForm.spuSlideShowPicList"
                ></el-image>
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="removeCertificate(i)"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </el-form-item>
          <div
            class="danger mb10"
            v-if="showUploadImg && wxAuditruleForm.qualification"
          >
            {{ wxAuditruleForm.qualification }}
          </div>
        </el-form>
        <div class="dialog-footer flex flex-center">
          <span slot="footer">
            <el-button
              v-if="!showUploadImg"
              @click="audit('wxAuditruleForm', 'sub')"
              size="small"
              type="primary"
              >确认提交审核</el-button
            >
            <el-button
              v-if="showUploadImg"
              @click="auditPic('wxAuditruleForm', 'sub')"
              size="small"
              type="primary"
              >确认提交审核</el-button
            >
          </span>
          <span slot="footer" style="padding-left: 50px">
            <el-button
              v-if="!showUploadImg"
              @click="audit('wxAuditruleForm', 'reSub')"
              size="small"
              type="primary"
              >重新提交审核</el-button
            >
            <el-button
              v-if="showUploadImg"
              @click="auditPic('wxAuditruleForm', 'reSub')"
              size="small"
              type="primary"
              >重新提交审核</el-button
            >
          </span>
        </div>
      </el-dialog>
      <el-dialog
        title="微信审核通过的类目"
        :close-on-click-modal="false"
        :visible.sync="showAuditCategory"
        width="1000px"
      >
        <el-form
          :model="wxAuditruleForm"
          :rules="wxAuditRules"
          ref="wxAuditruleForm"
          label-width="120px"
        >
          <el-form-item label="产品行业类目" prop="thirdRelationId">
            <el-cascader
              v-if="wxAuditDialogVisible"
              :show-all-levels="false"
              :options="options"
              filterable
              v-model="wxAuditruleForm.thirdRelationId"
              size="small"
              :props="{ label: 'cat_name', value: 'all', children: 'childs' }"
              clearable
            >
            </el-cascader>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog
        :before-close="handleClose"
        :close-on-click-modal="false"
        :visible.sync="byGoodsSnDialogVisible"
        width="1000px"
        title="查询的商品"
      >
        <el-dialog
          append-to-body
          :visible.sync="errValidGoods"
          width="500px"
          title="提示"
        >
          <div>
            <div>
              您有
              <span class="error">{{ errInputResult.length }}</span
              >条数据有误,查不到商品
            </div>
            <el-table :data="errInputResult" border class="small-table">
              <el-table-column
                prop="goodsSn"
                header-align="center"
                align="center"
                label="无效货号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="specBarcode"
                label="无效条码"
              ></el-table-column>
            </el-table>
          </div>
        </el-dialog>
        <div @click="batchSetting" class="pointer mb10">
          <span class="delete-icon hmicon icon-xitong"></span>
          批量设置
        </div>
        <el-table
          :data="successResult"
          stripe
          border
          class="small-table"
          max-height="500"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            show-overflow-tooltip
            label="商品名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="goodsSnAndBarcode"
            show-overflow-tooltip
            label="商品编码/条码"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="brandName"
            label="商品品牌"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuType"
            label="商品类型"
          >
            <template slot-scope="scope">
              <el-tag type="warning"
                >{{
                  scope.row.spuType === "virtual" ? "虚拟" : "实物"
                }}商品</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="可售门店"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="salesState"
            label="上架状态"
          >
            <template slot-scope="scope">
              <span class="status danger" v-show="scope.row.salesState === 0"
                >下架</span
              >
              <span class="status success" v-show="scope.row.salesState === 1"
                >上架</span
              >
            </template>
          </el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog
        title="微店商品设置"
        :close-on-click-modal="false"
        :visible.sync="sellOutSetdialogVisible"
        width="1000px"
      >
        <el-form
          :model="sellOutRuleForm"
          :rules="sellOutRules"
          ref="sellOutRuleForm"
          label-width="150px"
        >
          <el-form-item label="是否展示售罄商品：" prop="sellOutGoodsState">
            <el-switch
              v-model="sellOutRuleForm.sellOutGoodsState"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
            <div class="tips-gray mt10">
              开启后将按照以下样式显示售罄,关闭后不显示售罄商品
            </div>
          </el-form-item>
          <el-form-item
            label="自定义售罄图标："
            prop="sellOutState"
            v-if="sellOutRuleForm.sellOutGoodsState !== 'close'"
          >
            <el-switch
              v-model="sellOutRuleForm.sellOutState"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="open"
              inactive-value="close"
            ></el-switch>
            <div class="tips-gray mt10">
              开启后将按照以下样式显示售罄,关闭后按照默认样式
            </div>
          </el-form-item>
          <el-form-item
            label="预览图："
            prop="previewImgPath"
            v-if="sellOutRuleForm.sellOutGoodsState !== 'close'"
          >
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="sellOutShowUploadImg"
              v-if="sellOutShowUploadImg"
              noCircle
              noSquare
              :width="imgWidth"
              :height="imgHeight"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'goodsCenter' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <div class="flex">
              <div
                class="flex goods-upload-btn"
                @click="addGoodsImg('previewImgPath')"
                v-if="!sellOutRuleForm.previewImgPath"
              >
                <div
                  style="margin-left: 0px"
                  class="btn flex flex-column flex-center open-file item-center"
                >
                  <div class="add-prize-img-wrapper">
                    <span class="hmicon icon-hao pointer"></span>
                  </div>
                  <span>添加图片</span>
                </div>
              </div>
              <div v-else class="flex item-end priviews priviews2">
                <el-image
                  class="img"
                  :src="sellOutRuleForm.previewImgPath"
                  alt="logo"
                  :preview-src-list="[sellOutRuleForm.previewImgPath]"
                />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button
                    type="text"
                    @click="handleRemovePrePic('previewImgPath')"
                    >删除</el-button
                  >
                </div>
              </div>
              <div class="tips ml20">
                1.上传图片大小330*330，支持图片jpg、png格式<br />
                2.首页展示状态显示时必须上传图片,
              </div>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button
            size="small"
            type="primary"
            @click="saveRuleForm('sellOutRuleForm')"
            >保存</el-button
          >
          <el-button size="small" @click="closeRuleForm">取 消</el-button>
        </span>
      </el-dialog>
    </hm-content>
    <el-drawer
      title="更多筛选"
      :visible.sync="drawer"
      direction="rtl"
      size="730px"
    >
      <div class="drawer-search shop-list">
        <div class="flex flex-center mb10">
          <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.brandId"
            placeholder="请选择商品品牌"
          >
            <el-option
              :label="v.brandName"
              :value="v.brandId"
              v-for="(v, i) in allBrandList.records"
              :key="i"
            ></el-option>
          </el-select>
          <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.spuType"
            placeholder="请选择商品类型"
          >
            <el-option label="实物" value="reality"></el-option>
            <el-option label="虚拟" value="virtual"></el-option>
          </el-select>
          <el-select
            filterable
            clearable
            size="small"
            class="flex-1"
            v-model="searchCondition.overstockSales"
            placeholder="请选择是否开启预售"
          >
            <el-option label="已开启" value="open"></el-option>
            <el-option label="未开启" value="close"></el-option>
          </el-select>
        </div>
        <div class="flex flex-center mb10">
          <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.spuMainPic"
            placeholder="请选择是否有主图"
          >
            <el-option label="有主图" value="yes"></el-option>
            <el-option label="无主图" value="no"></el-option>
          </el-select>
          <el-select
            size="small"
            v-model="searchCondition.expressId"
            filterable
            class="mr10 flex-1"
            clearable
            placeholder="请选择运费模板"
          >
            <el-option
              :label="v.expressName"
              :value="v.expressId"
              v-for="(v, i) in expressList"
              :key="i"
            ></el-option>
          </el-select>

          <el-select
            size="small"
            clearable
            placeholder="上架状态"
            v-model="searchCondition.salesState"
            class="flex-1"
            filterable
          >
            <el-option label="上架" value="up"></el-option>
            <el-option label="下架" value="down"></el-option>
          </el-select>
        </div>
        <div class="flex flex-center mb10">
          <el-cascader
            v-model="searchCondition.attributeId"
            placeholder="请选择辅助属性"
            :show-all-levels="false"
            size="small"
            class="mr10 flex-1"
            :props="attributeFunc"
            clearable
          ></el-cascader>
          <el-cascader
            v-model="searchCondition.categoryId"
            :show-all-levels="false"
            size="small"
            class="mr10 flex-1"
            style="100px"
            :props="categoryFuncs"
            clearable
            placeholder="请选择类目"
          ></el-cascader>
          <div class="flex-1">
            <el-input
              clearable
              style="width: 100px"
              v-model.trim="searchCondition.minPrice"
              placeholder="最低零售价"
              size="small"
              class="ipt"
            ></el-input>
            -
            <el-input
              clearable
              style="width: 100px"
              v-model.trim="searchCondition.maxPrice"
              placeholder="最高零售价"
              size="small"
              class="ipt"
            ></el-input>
          </div>
        </div>
        <div class="mb10">
          <el-date-picker
            v-model="searchCondition.applyDate"
            type="datetimerange"
            align="right"
            start-placeholder="请选择创建时间段"
            end-placeholder="请选择创建时间段"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            size="small"
            class="mr10 time"
          ></el-date-picker>
          <el-select
            clearable
            v-model="searchCondition.shopId"
            placeholder="请选择可销售门店"
            size="small"
            filterable
            class="mr10"
          >
            <el-option label="全部门店" value=""></el-option>
            <el-option
              :label="v.shopName"
              :value="v.shopId"
              v-for="(v, i) in microShopStoreList"
              :key="i"
            ></el-option>
          </el-select>
        </div>
        <div class="mb10">
          <el-input
            clearable
            style="width: 400px"
            v-model.trim="searchCondition.keyWords"
            size="small"
            :placeholder="placeholder"
            class="ipt mr10"
          >
            <el-select
              slot="prepend"
              size="small"
              style="width: 100px"
              @change="selectQueryType"
              v-model="searchCondition.queryType"
            >
              <el-option label="商品名" value="spu_name"></el-option>
              <el-option label="货号" value="goods_sn"></el-option>
              <el-option label="条码" value="spec_barcode"></el-option>
            </el-select>
          </el-input>
        </div>
        <div class="mb10">
          <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.shareGoodsState"
            placeholder="请选择佣金状态"
          >
            <el-option label="是" value="yes"></el-option>
            <el-option label="否" value="no"></el-option>
          </el-select>
          <el-select
            filterable
            clearable
            size="small"
            class="mr10 flex-1"
            v-model="searchCondition.isOverseas"
            placeholder="请选择是否海外商品"
          >
            <el-option label="是" value="yes"></el-option>
            <el-option label="否" value="no"></el-option>
          </el-select>
        </div>
        <div class="flex flex-end">
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <el-button type="info" size="small" @click="searchCondition = {}"
            >重置</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="output"
            :loading="isOutputing"
            >导出全部明细</el-button
          >
        </div>
      </div>
    </el-drawer>

    <!-- 导入导出 -->
    <el-dialog
      :visible.sync="downloadVisible"
      width="40%"
      title="下载模板"
      :close-on-click-modal="false"
    >
      <el-form
        ref="downloadForm"
        :model="downloadForm"
        :rules="downloadRules"
        label-width="100px"
      >
        <el-form-item label="导出类型" prop="downloadType">
          <el-radio-group
            v-model="downloadForm.downloadType"
            :disabled="title === '导出类型'"
          >
            <div
              style="
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                align-items: flex-start;
                padding-top: 12px;
              "
            >
              <el-radio style="margin-bottom: 10px" label="1"
                >批量修改商品价格模板</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="2"
                >商品货号模板</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="dowloadConfirm('downloadForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="downloadVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="exportVisible"
      width="40%"
      title="导入"
      @close="closeExport"
    >
      <el-form
        ref="exportForm"
        :model="exportForm"
        :rules="exportRules"
        label-width="100px"
      >
        <el-form-item label="导入类型" prop="exportType">
          <el-radio-group
            v-model="exportForm.exportType"
            :disabled="title === '导入类型'"
          >
            <div
              style="
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                align-items: flex-start;
                padding-top: 12px;
              "
            >
              <el-radio style="margin-bottom: 10px" label="1"
                >批量修改商品价格模板</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="2"
                >商品货号模板</el-radio
              >
            <el-radio style="margin-bottom: 10px" label="3"
                >建议零售价与网店售价修改</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '1'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importfChangePrice"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '2'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importf"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '3'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importfBarcode"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="uploadedFile">
          <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon el-icon-s-order"></span>
            {{ filesName }}
          </div>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="exportConfirm('downloadForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="closeExport">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import HmImportTemp from "@/components/HmImportTemp";
import { setCookie, getCookie } from "@/utils/utils";
// import XLSX from "xlsx";
import * as XLSX from "xlsx/xlsx";
import { getLoginUser, getUserName } from "@/utils/auth";
import myUpload from "vue-image-crop-upload";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: { HmImportTemp, myUpload },
  data() {
    const patternDelay = function (rule, val, callback) {
      if (this.batchCondition.overstockSales === "open") {
        if (
          !this.batchCondition.afterPayDays &&
          !this.batchCondition.deliveryDeadline
        ) {
          return callback(new Error("请选择预购发货时间"));
        }
        callback();
      }
      callback();
    }.bind(this);
    return {
      title: "",
      expressFlag: true,
      drawer: false,
      successResult: [],
      downloadVisible: false,
      exportVisible: false,
      uploadedFile: false,
      filesName: "",
      downloadForm: {
        downloadType: "1",
      },
      downloadRules: {
        downloadType: {
          required: true,
          message: "请选择模板类型",
          trigger: "blur",
        },
      },
      exportForm: {
        exportType: "1",
        uploadFile: "",
      },
      exportRules: {
        exportType: {
          required: true,
          message: "请选择模板类型",
          trigger: "blur",
        },
        uploadFile: {
          required: true,
          message: "请上传文件",
          trigger: "blur",
        },
      },
      byGoodsSnDialogVisible: false,
      showAuditCategory: false,
      errInputResult: [],
      errValidGoods: false,
      wxAuditruleForm: {
        license: [],
        certificate: [],
        thirdRelationId: [],
        qualification: "",
        product_qualification: "",
      },
      wxAuditRules: {
        thirdRelationId: {
          required: true,
          message: "请选择产品行业类目",
          trigger: "blur",
        },
        license: {
          required: true,
          message: "请上传图片",
          trigger: "blur",
        },
      },
      uploadShow: true,
      certificateShow: true,
      codeInfoModelList: [],
      wxAuditDialogVisible: false,
      hidden: true,
      tabType: "goodsName",
      editwxName: "",
      activityCode: "",
      qrcodeDialogVisible: false,
      isSave: "",
      num: 0,
      selectOther: false,
      selectAll: false,
      stockDialogVisible: false,
      priceType: "money",
      stockList: [],
      batchPrice: "",
      groupType: "",
      spuId: "",
      price: {},
      ruleForm: [],
      group: [],
      checkedGoods: [],
      checkAll: false,
      isIndeterminate: false,
      tHeader: [],
      tBody: [],
      dialogVisible: false,
      dialogVisiblePrice: false,
      importTempVisible: false,
      checkedRow: [],
      spuIdList: [],
      categoryOperatorLabelName: "修改分类为",
      batchCondition: {
        deliveryMode: [],
        expressId: "",
        couponUsable: "yes",
        recycleState: "yes",
        categoryOperationType: "edit",
        oldWord: "",
        newWord: "",
        categoryRelModelList: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: [],
        overstockSales: "close",
        overstockSalesMode: "",
        memberPrices: "",
        deliveryDeadline: "",
        memberLaunchRefund: "no",
        markingPrice: "",
        afterPayDays: "",
        spuType: "",
        eachMemberPurchaseLimit: "",
        salesStartTime: "",
        upStartTime: "",
        downStartTime: "",
        priceType: "discount",
        shareState: "yes",
        stockNum: 0,
        netWeight: "",
        weightUnit: "",
      },
      rules: {
        overstockSalesMode: {
          validator: patternDelay,
          trigger: "blur",
        },
        deliveryMode: {
          required: true,
          message: "请选择配送方式",
          trigger: "blur",
        },
        expressId: {
          required: true,
          message: "请选择运费模板",
          trigger: "blur",
        },
      },
      placeholder: "请输入商品名",
      searchCondition: {
        salesState: "up",
        queryType: "spu_name",
        queryShareGoodsMode: "yes",
      },
      verificationCondition:{
        queryType: "queryData"
      },
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,
      tips: "",
      categoryFuncs: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId,
              })
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      categoryProp: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId,
              })
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },

      categoryFunc: {
        multiple: true,
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  v.value = JSON.stringify({
                    wxshopCategoryId: v.wxshopCategoryId,
                    categoryName: v.categoryName,
                  });
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId,
              })
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    v.value = JSON.stringify({
                      wxshopCategoryId: v.wxshopCategoryId,
                      categoryName: v.categoryName,
                    });
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then((res) => {
              res.result.forEach((v) => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId,
              };
            } else {
              params = {
                attributeId: node.data.valueId,
              };
            }
            this.$store
              .dispatch("queryAttrListByAddGoods", params)
              .then((res) => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach((v) => {
                    v.value = v.valueId;
                    v.label = v.attributeValue;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      expressList: [],
      memberGroupList: [],
      wxshopSpuBos: [],
      salesChannels: [
        {
          name: "门店自提",
          value: "mdzt",
        },
        {
          name: "快递发货",
          value: "kdfh",
        },
        {
          name: "同城配送",
          value: "tcps",
        },
      ],
      sort: {},
      options: [],
      wechatAuditInfo: {},
      showUploadImg: false,
      product_qualification_type: false,
      sellOutSetdialogVisible: false,
      sellOutRuleForm: {
        sellOutGoodsState: "open",
        sellOutState: "close",
        previewImgPath: "",
      },
      sellOutRules: {},
      uploadType: "",
      sellOutShowUploadImg: false,
      imgWidth: 0,
      imgHeight: 0,
      storeCode: "",
    };
  },
  created() {
    this.$store.dispatch("queryBrandAllList", {
      pageSize: 999999,
      pageNo: 1,
      loading: true,
    });
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    this.bathEditWxshopStockTips();
    this.queryStoreConfigSellOut();
  },

  activated() {
    if (this.$route.query.wxshopCategoryId) {
      this.searchCondition.wxshopCategoryId =
        this.$route.query.wxshopCategoryId;
    } else {
      this.getParamsCookie();
    }
    this.tHeader = this.$refs.brandTable.columns
      .map((o) => {
        return o.label !== "序号" && o.label !== "操作" && o.label;
      })
      .filter((o) => o);
    this.tBody = this.$refs.brandTable.$children
      .map((o) => o._props.prop)
      .filter((o) => o);
    this.$store.dispatch("querySalesChannels");
    this.queryList();
    this.queryExpressList();
    this.queryMemberGroup();
    this.$store.dispatch("queryMicroStoreList");
  },
  computed: mapGetters([
    "microShopGoodsList",
    "allMicroShopGoodsList",
    "microShopStoreList",
    "allBrandList",
  ]),
  watch: {
    batchPrice(val) {
      if (this.groupType !== "") {
        this.ruleForm.skuModelList.forEach((o) => {
          let x = o.groupList[this.groupType].groupId;

          o.groupList[this.groupType][
            o.skuId ? `${o.skuId}&&&${x}` : `${this.ruleForm.skuId}&&&${x}`
          ] = val;
        });
      } else {
        this.batchPrice = "";
        this.$message({
          type: "warning",
          message: "请先选择会员群组",
        });
      }
    },
    activityCategoryList(val) {
      this.activityChildCategoryList = [];
      val.forEach((v) => {
        this.activityChildCategoryList = this.activityChildCategoryList.concat(
          v.nodes
        );
      });
    },
  },
  methods: {
    closeExport() {
      this.exportVisible = false;
      this.uploadedFile = false;
      this.filesName = "";
      this.exportForm = {
        exportType: "1",
        uploadFile: "",
      };
      this.exportVisible = false;
    },
    dowloadConfirm() {
      console.log("导出模板类型", this.downloadForm);
      if (this.downloadForm.downloadType == 1) {
        this.outputExcelChangePrice();
      } else if (this.downloadForm.downloadType == 2) {
        this.outputExcel();
      }
    },
    beforeAvatarUpload(file) {
      // 限制上传文件的类型
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        this.$message.error("上传文件只能是 Excel 格式!");
        return false;
      }
      return true;
    },
    exportConfirm() {
      let that = this;
      console.log("导入数据", this.exportForm);
      if (
        this.exportForm.exportType != "" &&
        this.exportForm.uploadFile != ""
      ) {
        if (this.exportForm.exportType == 1) {
          that.$store
            .dispatch("batchUpdatePrice", this.exportForm.uploadFile)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                that.exportVisible = false;
                that.uploadedFile = false;
                that.filesName = "";
                that.exportForm = {
                  exportType: "1",
                  uploadFile: "",
                };
                that.$nextTick(() => {
                  that.$message({
                    message: result,
                    type: "success",
                  });
                });
              } else if (code === "-1") {
                that.$message({
                  message: "批量修改微店商品价格失败",
                  type: "warning",
                });
              }
            });
        } else if (this.exportForm.exportType == 2) {
          that.$store
            .dispatch("queryAllMicroShopGoodsList", this.exportForm.uploadFile)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                if (result.records.length) {
                  that.byGoodsSnDialogVisible = true;
                  that.successResult = result.records;
                  that.checkedRow = result.records.map((v) => v.wxshopSpuId);
                  that.wxshopSpuBos = result.records;
                  that.exportVisible = false;
                  that.uploadedFile = false;
                  that.filesName = "";
                  that.exportForm = {
                    exportType: "1",
                    uploadFile: "",
                  };
                } else {
                  that.$message({
                    message: "根据货号查不到商品，请检查货号",
                    type: "warning",
                  });
                }
              }
            });
        } else if (this.exportForm.exportType == 3) {
          that.$store
            .dispatch("batchUpdatePrice", this.exportForm.uploadFile)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                that.exportVisible = false;
                that.uploadedFile = false;
                that.filesName = "";
                that.exportForm = {
                  exportType: "1",
                  uploadFile: "",
                };
                that.$nextTick(() => {
                  that.$message({
                    message: result,
                    type: "success",
                  });
                });
              } else if (code === "-1") {
                that.$message({
                  message: "批量修改微店商品价格失败",
                  type: "warning",
                });
              }
            });
        }
      } else {
        this.$message({
          message: "请选择导入模板类型和上传文件",
          type: "warning",
        });
      }
    },
    setCategoryOperator() {
      if (this.batchCondition.categoryOperationType === "create") {
        this.categoryOperatorLabelName = "新增分类为";
      } else if (this.batchCondition.categoryOperationType === "update") {
        this.categoryOperatorLabelName = "修改分类为";
      }
    },
    statistical(row) {
      let goodsInfo = JSON.stringify(row);
      this.$router.push({
        name: "GoodsCenterAnalysis",
        query: {
          goodsInfo,
        },
      });
    },
    deliveryModeChange(val) {
      if (val.indexOf("kdfh") < 0) {
        this.expressFlag = false;
        this.batchCondition.expressId = "";
      } else {
        this.expressFlag = true;
      }
    },
    handleClose(done) {
      this.checkedRow = [];
      done();
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号"];
        const data = [];

        exportJsonToExcel(tHeader, data, "导入商品货号模板");
        this.downloadVisible = false;
      });
    },
    // 批量修改商品价格模板导出excel
    outputExcelChangePrice() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商品货号", "商品名", "折扣金额"];
        const data = [];

        exportJsonToExcel(tHeader, data, "批量修改商品价格导入模板");
        this.downloadVisible = false;
      });
    },

    // 导入excel
    importf(e) {
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (obj.files[0]) {
      //   return
      // }
      if (!e.raw) {
        return;
      }
      // let f = obj.files[0];
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const goodsSnList = [];
        result.forEach((v) => {
          goodsSnList.push(v[0]);
        });
        let params = {
          pageSize: 99999,
          pageNo: 1,
          goodsSnList,
        };

        that.uploadedFile = true;
        that.exportForm.uploadFile = params;

        // if (isValid && isRequired) {
        //   that.rightData = formatResult;
        //   // that.memberCount = formatResult.length;
        // } else {
        //   if (!isRequired) {
        //     that.$message({
        //       message: "导入失败，请导入完整商品信息！",
        //       type: "warning"
        //     });
        //   } else if (!isValid) {
        //     that.$message({
        //       message: "导入失败，日期请使用文本格式导入！",
        //       type: "warning"
        //     });
        //   }
        // }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      // obj.value = "";
      e.value = "";
    },
    // 批量改价商品导入excel
    importfChangePrice(e) {
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (obj.files[0]) {
      //   return
      // }
      if (!e.raw) {
        return;
      }
      // let f = obj.files[0];
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log("result:",result);
        const goodsSnList = [];
        let list = result.map((v) => {
          if (v[0].indexOf("货号：") != -1) {
            return {
              goodsSn: v[0].split("货号：")[1],
              price: v[2],
            };
          } else if (v[0].indexOf("货号:") != -1) {
            return {
              goodsSn: v[0].split("货号:")[1],
              price: v[2],
            };
          } else {
            return {
              goodsSn: v[0],
              price: v[2],
            };
          }
        });
        console.log("list:", list);
        that.uploadedFile = true;
        that.exportForm.uploadFile = list;
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      // obj.value = "";
      e.value = "";
    },
    // 建议零售价与网店售价修改
    importfBarcode(e) {
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (obj.files[0]) {
      //   return
      // }
      if (!e.raw) {
        return;
      }
      // let f = obj.files[0];
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        // console.log("result:",result);
        const specBarcodeList = [];
        let list = result.map((v) => {
          if (v[1].indexOf("货号：") != -1 && v[2].indexOf("条码：") != -1) {
            return {
              goodsSn: v[1].split("货号：")[1],
              specBarcode: v[2].split("条码：")[1],
              price: v[4]
            };
          } else if (v[1].indexOf("货号：") != -1 && v[2].indexOf("条码：") != -1) {
            return {
              goodsSn: v[1].split("货号:")[1],
              specBarcode: v[2].split("条码：")[1],
              price: v[4]
            };
          } else {
            return {
              goodsSn: v[1],
              specBarcode: v[2],
              price: v[4]
            };
          }
        });
        console.log("list:", list);
        that.uploadedFile = true;
        that.exportForm.uploadFile = list;
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      // obj.value = "";
      e.value = "";
    },
    optionsChange(val) {
      console.log(val);
      if (val) {
        if (val[val.length - 1].qualification_type != "0") {
          this.showUploadImg = true;
          this.product_qualification_type = true;
        } else if (val[val.length - 1].product_qualification_type != "0") {
          this.product_qualification_type = true;
          this.showUploadImg = false;
        }
        // this.showUploadImg =
        //   val[val.length - 1].product_qualification_type === "0" ? false : true;
        this.wxAuditruleForm.product_qualification =
          val[val.length - 1].product_qualification;
        this.wxAuditruleForm.qualification = val[val.length - 1].qualification;
      } else {
        this.showUploadImg = false;
        this.product_qualification_type = false;
      }
    },
    async getWeChatShopCategory() {
      const { code, result } = await this.$store.dispatch(
        "getWeChatShopCategory"
      );
      if (code === "0") {
        this.forTree(result);
        this.options = result;
        return code;
      }
    },
    async getWeChatShopSpuEdit(row) {
      const { code, result, errMsg, inMsg } = await this.$store.dispatch(
        "weChatShopSpuGet",
        { wxshopSpuId: row.wxshopSpuId }
      );
      if (code === "0") {
        console.log("result:", result);
        if (result != null && result.status) {
          switch (result.status) {
            case 0:
              this.wechatAuditInfo.status = "初始值";
              break;
            case 5:
              this.wechatAuditInfo.status = "上架";
              break;
            case 11:
              this.wechatAuditInfo.status = "自主下架";
              break;
            case 13:
              this.wechatAuditInfo.status = "违规下架/风控系统下架";
              break;
          }
          this.wechatAuditInfo.reject_reason = "";
          this.wechatAuditInfo.errmsg = "";
        }
        if (result != null && result.edit_status) {
          switch (result.edit_status) {
            case 1:
              this.wechatAuditInfo.edit_status = "未审核";
              break;
            case 2:
              this.wechatAuditInfo.edit_status = "审核中";
              break;
            case 3:
              this.wechatAuditInfo.edit_status = "审核失败";
              break;
            case 4:
              this.wechatAuditInfo.edit_status = "审核成功";
              break;
          }
        }
        if (
          result != null &&
          result.audit_info &&
          result.audit_info.reject_reason
        ) {
          this.wechatAuditInfo.reject_reason = result.audit_info.reject_reason;
        }
        if (
          result == null &&
          inMsg != null &&
          inMsg.indexOf("商品id不存在") != -1
        ) {
          this.wechatAuditInfo.status = "";
          this.wechatAuditInfo.edit_status = "商品未提交";
        }
      } else {
        this.wechatAuditInfo.errmsg = errMsg;
        this.wechatAuditInfo.status = "";
        this.wechatAuditInfo.edit_status = "";
      }
      console.log("this.wechatAuditInfo:", this.wechatAuditInfo);
    },
    //递归遍历
    forTree(arr) {
      arr.forEach((v) => {
        //遍历树
        v.all = {
          cat_name: v.cat_name,
          show_cat_id: v.show_cat_id,
          product_qualification_type: v.product_qualification_type,
          qualification_type: v.qualification_type,
          product_qualification: v.product_qualification,
          qualification: v.qualification,
        };
        if (v.hasOwnProperty("childs") && v.childs && v.childs.length) {
          this.forTree(v.childs);
        } else {
          return;
        }
      });
    },
    // 正在上传
    uploading(type) {
      if (type === "license") {
        this.uploadShow = true;
      } else if (type === "certificate") {
        this.certificateShow = true;
      }
    },
    // 移除上传文件
    handleRemove(i) {
      this.wxAuditruleForm.license.splice(i, 1);
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.wxAuditruleForm.license.push(jsonData.result);
        this.uploadShow = false;
      }
    },
    removeCertificate(i) {
      this.wxAuditruleForm.certificate.splice(i, 1);
    },
    uploadCertificateSucc(jsonData) {
      if (jsonData.code === 0) {
        this.wxAuditruleForm.certificate.push(jsonData.result);
        this.certificateShow = false;
      }
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      // const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      // if (!limitSize) {
      //   this.$message({
      //     message: "上传模板大小不能超过 1M!",
      //     type: "warning"
      //   });
      // }
      return extension || extension2 || extension3 || extension4;
      // && limitSize;
    },
    sortChange(sort) {
      this.sort = sort;
      this.queryList();
    },
    async queryMemberGroup() {
      const { result } = await this.$store.dispatch("queryAllMemberGroupList", {
        pageSize: 99999,
        pageNo: 1,
      });

      this.memberGroupList = result.records;
    },
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
      }
      this.expressList.push(...result.templateList);
    },
    async audit(formName, type) {
      try {
        const valid = await this.$refs[formName].validate();

        if (valid) {
          let params = JSON.parse(JSON.stringify(this.wxAuditruleForm));
          params.thirdCatId =
            this.wxAuditruleForm.thirdRelationId[
              this.wxAuditruleForm.thirdRelationId.length - 1
            ].show_cat_id;
          params.productQualificationType =
            this.wxAuditruleForm.thirdRelationId[
              this.wxAuditruleForm.thirdRelationId.length - 1
            ].product_qualification_type;
          // params.wxshopSpuId = this.row.wxshopSpuId;
          let wxshopSpuIdList = [];
          if (this.checkedRow && this.checkedRow.length > 0) {
            wxshopSpuIdList = this.checkedRow;
          } else if (this.row.wxshopSpuId) {
            wxshopSpuIdList.push(this.row.wxshopSpuId);
          }
          params.wxshopSpuIdList = wxshopSpuIdList;

          let code = "0";
          let result = "";
          if (type === "reSub") {
            code,
              (result = await this.$store.dispatch(
                "weChatShopSpuEdit",
                params
              ));
          } else {
            code,
              (result = await this.$store.dispatch("weChatShopSpuAdd", params));
          }

          if (code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.wxAuditDialogVisible = false;
            this.queryList();
          }
          console.log("result1:::", result);
          if (result && result.length > 0) {
            this.$message({
              message: result,
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log("error: ", error);
        return;
      }
    },
    async auditPic(formName, type) {
      console.log("图片上传类型");
      try {
        const valid = await this.$refs[formName].validate();
        if (valid) {
          let level1 = "";
          let level2 = "";
          let level3 = "";
          if (
            this.wxAuditruleForm.thirdRelationId &&
            this.wxAuditruleForm.thirdRelationId.length > 0
          ) {
          }
          {
            level1 = this.wxAuditruleForm.thirdRelationId[0].show_cat_id;
            if (this.wxAuditruleForm.thirdRelationId.length == 2) {
              level2 = this.wxAuditruleForm.thirdRelationId[1].show_cat_id;
            }
            if (this.wxAuditruleForm.thirdRelationId.length == 3) {
              level2 = this.wxAuditruleForm.thirdRelationId[1].show_cat_id;
              level3 = this.wxAuditruleForm.thirdRelationId[2].show_cat_id;
            }
          }
          let license = this.wxAuditruleForm.license[0];
          let certificate = this.wxAuditruleForm.certificate[0];
          let categoryInfo = {};
          categoryInfo.level1 = level1;
          categoryInfo.level2 = level2;
          categoryInfo.level3 = level3;
          categoryInfo.certificate = certificate;
          let req = {
            categoryInfo: categoryInfo,
            license: license,
          };
          console.log("params:", level1, level2, level3, license);
          let code = "0";
          let result = "";
          if (type === "reSub") {
            code,
              (result = await this.$store.dispatch("weChatShopSpuEdit", req));
          } else {
            code,
              (result = await this.$store.dispatch("shopAuditCategory", req));
          }

          if (code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.wxAuditDialogVisible = false;
            this.queryList();
          }
          console.log("result:::", result);
          if (result && result.length > 0) {
            this.$message({
              message: result,
              type: "warning",
            });
          }
        }
      } catch (error) {
        console.log("error: ", error);
        return;
      }
    },
    async showAuditCat() {
      this.showAuditCategory = true;
      this.wxAuditDialogVisible = true;
      console.log("查看审核通过的类目");
      const { result, code } = await this.$store.dispatch(
        "getWeChatShopCategoryList"
      );
      console.log("result: ", result);
      if (code === "0") {
        this.options = result;
      }
    },
    async editSpuShareState(row) {
      let changeShareState;
      if (row.shareState === "yes") {
        changeShareState = "no";
      } else {
        changeShareState = "yes";
      }
      let params = {
        wxshopSpuId: row.wxshopSpuId,
        shareState: changeShareState,
      };
      const { result } = await this.$store
        .dispatch("editSpuShareState", params)
        .then((res) => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.queryList();
          }
        });
    },
    wxAudit(row) {
      this.getWeChatShopCategory().then(() => {
        this.wxAuditDialogVisible = true;
      });
      this.getWeChatShopSpuEdit(row);
      this.row = row;
      this.showUploadImg = false;
      this.product_qualification_type = false;
      setTimeout(() => {
        if (this.$refs.wxAuditruleForm) {
          this.$refs.wxAuditruleForm.resetFields();
        }
        this.wxAuditruleForm.license = [];
      }, 0);
    },
    hide(row) {
      this.$confirm("隐藏本行数据将加入回收站?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("wxGoodsHide", {
            wxshopSpuId: row.wxshopSpuId,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.queryList();
            }
          });
      });
    },
    del(row) {
      this.$confirm("删除本行数据将加入回收站，并下线?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store
          .dispatch("delWxshopspuGoods", {
            wxshopSpuId: row.wxshopSpuId,
          })
          .then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.queryList();
            }
          });
      });
    },
    selectQueryType(queryType) {
      if (queryType === "spuName") {
        this.placeholder = "请输入商品名";
      } else if (queryType === "goodsSn") {
        this.placeholder = "请输入货号";
      } else if (queryType === "specBarcode") {
        this.placeholder = "请输入条码";
      } else if (queryType === "brandName") {
        this.placeholder = "请输入品牌名";
      }
    },
    changeEnddate(index, rowdata) {
      this.editwxName = rowdata.wxshopSpuName;
      this.microShopGoodsList.records[index].edit_enddate =
        !this.microShopGoodsList.records[index].edit_enddate; //直接加key
      this.microShopGoodsList.records = [...this.microShopGoodsList.records];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateblur(index, rowdata) {
      if (
        rowdata.wxshopSpuName === "" ||
        rowdata.wxshopSpuName === this.editwxName
      ) {
        rowdata.wxshopSpuName = this.editwxName;
        this.microShopGoodsList.records = [...this.microShopGoodsList.records];
      } else {
        let params = {
          wxshopSpuName: rowdata.wxshopSpuName,
          wxshopSpuId: rowdata.wxshopSpuId,
        };
        this.$store.dispatch("editWxshopSpuName", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.queryList();
          }
        });
      }
      this.microShopGoodsList.records[index].edit_enddate =
        !this.microShopGoodsList.records[index].edit_enddate;
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this.batchCondition[prop].length === 1) {
        this.batchCondition[prop] = this.batchCondition[prop].replace(
          /[^0-9]/g,
          ""
        );
      } else {
        this.batchCondition[prop] = this.batchCondition[prop].replace(
          /^(0+)|\D/g,
          ""
        );
      }
    },
    async productQrcode(row) {
      // const { storeCode } = getToken();
      // console.log("getToken(): ", getToken());
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      let params = {
        path: `pages/product/product?wxshopSpuId=${row.wxshopSpuId}`,
        storeCode: storeCode,
        createBy: userName,
        shareFunction: "微店商品中心-商品二维码",
        shareFrom: "bg",
      };
      const url = await this.$store.dispatch("shareDataSaveV2", params);
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path: `pages/product/product?saveUUID=${url.result}`,
        storeCode: row.storeCode,
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    copy(wxshopSpuId) {
      let text = `pages/product/product.html?wxshopSpuId=${wxshopSpuId}`;
      let oInput = document.createElement("input");
      oInput.value = text;
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.className = "oInput";
      oInput.style.display = "none";
      this.$message({
        message: "复制成功",
        type: "success",
      });
    },
    async output() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;
      searchCondition.wxshopCategoryId = this.isArray(
        searchCondition.wxshopCategoryId
      )
        ? searchCondition.wxshopCategoryId[
            searchCondition.wxshopCategoryId.length - 1
          ]
        : searchCondition.wxshopCategoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      searchCondition.createStartTime = this.isArray(
        this.searchCondition.applyDate
      )
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.createEndTime = this.isArray(
        this.searchCondition.applyDate
      )
        ? searchCondition.applyDate[1]
        : "";
      this.$store.dispatch("wxSkuExport", searchCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.hidden = false;
        this.drawer = false;
      }, 0);

      // require.ensure([], () => {
      //   const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
      //   const tHeader = [
      //     "商品名",
      //     "商品品牌",
      //     "商品类型",
      //     "是否开启预售",
      //     "主图",
      //     "条码",
      //     "货号",
      //     "线上分类一级",
      //     "线上分类二级",
      //     "线上分类三级",
      //     "线下分类一级",
      //     "线下分类二级",
      //     "线下分类三级",
      //     "品牌",
      //     "上架状态",
      //     "库存",
      //     "价格"
      //   ];
      //   const filterVal = [
      //     "wxshopSpuName",
      //     "brandName",
      //     "spuTypeFormat",
      //     "overstockSaleseFormat",
      //     "spuMainPic",
      //     "specBarCode",
      //     "goodsSn",
      //     "wxCategoryNameLevel1",
      //     "wxCategoryNameLevel2",
      //     "wxCategoryNameLevel3",
      //     "categoryNameLevel1",
      //     "categoryNameLevel2",
      //     "categoryNameLevel3",
      //     "brandName",
      //     "salesStateFormat",
      //     "stockNum",
      //     "wxshopPrice"
      //   ];
      //   const searchCondition = JSON.parse(
      //     JSON.stringify(this.searchCondition)
      //   );
      //   searchCondition.categoryId = this.isArray(searchCondition.categoryId)
      //     ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
      //     : searchCondition.categoryId;
      //   searchCondition.wxshopCategoryId = this.isArray(
      //     searchCondition.wxshopCategoryId
      //   )
      //     ? searchCondition.wxshopCategoryId[
      //         searchCondition.wxshopCategoryId.length - 1
      //       ]
      //     : searchCondition.wxshopCategoryId;

      //   searchCondition.attributeId = this.isArray(searchCondition.attributeId)
      //     ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
      //     : "";
      //   searchCondition.createStartTime = this.isArray(
      //     this.searchCondition.applyDate
      //   )
      //     ? searchCondition.applyDate[0]
      //     : "";
      //   searchCondition.createEndTime = this.isArray(
      //     this.searchCondition.applyDate
      //   )
      //     ? searchCondition.applyDate[1]
      //     : "";
      //   this.$store
      //     .dispatch("queryExportMicroShopGoodsList", searchCondition)
      //     .then(res => {
      //       res.result.forEach(v => {
      //         v.salesStateFormat = v.salesState === 1 ? "上架" : "下架";
      //         v.spuTypeFormat = v.spuType === "reality" ? "实物" : "虚拟";
      //         v.overstockSaleseFormat =
      //           v.overstockSales === "open" ? "已开启" : "未开启";
      //       });
      //       const data = this.formatJson(filterVal, res.result);
      //       exportJsonToExcel(
      //         tHeader,
      //         data,
      //         "微店商品列表" + new Date().toLocaleString()
      //       );
      //     });
      // });
    },
    async priceVerification() {
      console.log(1111);
      const verificationCondition = JSON.parse(JSON.stringify(this.verificationCondition));
      this.$store.dispatch("wxPriceVerification", verificationCondition);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.hidden = false;
        this.drawer = false;
      }, 0);
    },
    
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex((o) => o !== "all") > -1;
      this.selectAll = storeList.findIndex((o) => o === "all") > -1;
    },
    filterInteger(index, prop) {
      this.stockList[index].stockQty = prop.replace(".", "").replace("-", "");
    },
    changeRowStock(row) {
      if (row.stockQty && row.depotId) {
        this.setStock([
          {
            skuId: row.skuId,
            stockQty: row.stockQty,
            depotId: row.depotId,
            platformId: row.platformId,
          },
        ]);
      } else {
        this.$message({
          type: "warning",
          message: "请输入库存和仓库",
        });
      }
    },
    async setStock(params) {
      const { code } = await this.$store.dispatch("setCurrentStock", params);
      if (code === "0") {
        this.$message({
          type: "success",
          message: "操作成功",
        });
      }
      if (params.length > 1) {
        if (this.dialogVisible) {
          this.queryPurchaseList();
        } else {
          this.queryList();
        }
      }
    },
    async viewStock(row) {
      this.stockDialogVisible = true;
      const { result } = await this.$store.dispatch("queryStockSkuList", {
        spuId: row.spuId,
      });
      let list = [];
      result.map((v) => {
        if (v.depotStockList.length) {
          v.depotStockList.map((o) => {
            list.push({
              spuName: v.spuName,
              ...o,
            });
          });
        } else {
          list.push(v);
        }
      });
      this.stockList = list;
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
      this.checkedRow = [];
      this.spuIdList = [];
      this.tabType = "goodsName";
      this.batchCondition.batchCondition = "";
      this.batchCondition.deliveryDeadline = "";
      this.batchCondition.afterPayDays = "";
      this.batchCondition.memberLaunchRefund = "";
      this.batchCondition.overstockSales = "close";
      this.batchCondition.priceType = "discount";
      this.batchCondition.netWeight = "";
      this.batchCondition.weightUnit = "";
      this.wxshopSpuBos = [];
      this.batchCondition.expressId = "";
      this.byGoodsSnDialogVisible = false;
      this.queryMemberGroup();
    },
    submitRuleForm() {
      console.log("this.tabType:", this.tabType);
      if (this.tabType === "overstockSalesMode") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let batchCondition = {
              overstockSales: this.batchCondition.overstockSales,
              overstockSalesMode: this.batchCondition.overstockSalesMode,
              deliveryDeadline: this.batchCondition.deliveryDeadline,
              afterPayDays: this.batchCondition.afterPayDays,
            };

            // for (let key in this.batchCondition) {
            //   if (key !== "couponUsable" && key !== "recycleState") {
            //     batchCondition[key] = this.batchCondition[key];
            //   }
            // }

            // batchCondition.wxshopCategoryId =
            //   batchCondition.wxshopCategoryId[
            //     batchCondition.wxshopCategoryId.length - 1
            //   ];
            batchCondition.wxshopSpuIdList = this.checkedRow;

            let categoryRelModelList = [];
            if (this.batchCondition.categoryRelModelList.length) {
              this.batchCondition.categoryRelModelList.forEach((v) => {
                categoryRelModelList.push(JSON.parse(v[v.length - 1]));
              });
            }

            batchCondition.categoryRelModelList = categoryRelModelList;
            this.$store
              .dispatch("batchEditMicroShopGoods", batchCondition)
              .then((res) => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success",
                  });
                  this.queryList();
                  this.dialogVisible = false;
                  setTimeout(() => {
                    this.resetRuleForm();
                  }, 0);
                }
              });
          } else {
            return false;
          }
        });
      } else if (this.tabType === "memberPrices") {
        let spuPriceList = [];
        let flag = false;
        this.memberGroupList.map((v) => {
          if (!!v.value || v.value === 0) {
            spuPriceList.push({ groupId: v.groupId, value: v.value });
          }
        });
        if (this.batchCondition.priceType === "discount") {
          spuPriceList.forEach((v) => {
            if (new Number(v.value) > 10) {
              flag = true;
            }
          });
        }

        if (flag) {
          this.$message({
            message: "设置折扣不得大于10",
            type: "warning",
          });
        } else {
          let params = {
            priceType: this.batchCondition.priceType,
            spuIdList: this.checkedRow,
            spuPriceList,
          };

          this.$store.dispatch("batchMemberPriceAdd", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.queryList();
              this.dialogVisible = false;
              setTimeout(() => {
                this.resetRuleForm();
              }, 0);
            }
          });
        }
      } else if (this.tabType === "express") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let batchCondition = JSON.parse(
              JSON.stringify(this.batchCondition)
            );
            console.log("batchCondition: ", batchCondition);

            let params = {
              deliveryMode: JSON.stringify(batchCondition.deliveryMode),
              expressId: batchCondition.expressId,
              wxshopSpuBos: this.wxshopSpuBos,
            };
            this.$store.dispatch("batchBindExpress", params).then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.queryList();
                this.dialogVisible = false;
                setTimeout(() => {
                  this.resetRuleForm();
                }, 0);
              }
            });
          } else {
            return false;
          }
        });
      } else if (this.tabType === "recycleState") {
        let params = {
          wxshopSpuIdList: this.checkedRow,
          recycleState: this.batchCondition.recycleState,
        };
        this.$store.dispatch("batchEditMicroShopGoods", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.queryList();
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
          }
        });
      } else if (this.tabType === "shareState") {
        let params = {
          wxshopSpuIdList: this.checkedRow,
          shareState: this.batchCondition.shareState,
        };
        this.$store.dispatch("batchEditMicroShopGoods", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.queryList();
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
          }
        });
      } else if (this.tabType === "stockNum") {
        let params = {
          wxshopSpuIdList: this.checkedRow,
          stockNum: this.batchCondition.stockNum,
        };
        this.$store.dispatch("batchEditMicroShopGoods", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.queryList();
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
          }
        });
      } else if (this.tabType === "couponUsable") {
        let params = {
          wxshopSpuIdList: this.checkedRow,
          couponUsable: this.batchCondition.couponUsable,
        };
        this.$store.dispatch("batchEditMicroShopGoods", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.queryList();
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
          }
        });
      } else {
        let batchCondition = JSON.parse(JSON.stringify(this.batchCondition));
        batchCondition.wxshopSpuIdList = this.checkedRow;
        console.log(this.batchCondition.categoryOperationType);
        if (
          this.batchCondition.categoryOperationType &&
          this.batchCondition.categoryOperationType === "edit"
        ) {
          this.batchCondition.categoryOperationType = null;
        }
        let categoryRelModelList = [];
        if (batchCondition.categoryRelModelList.length) {
          batchCondition.categoryRelModelList.forEach((v) => {
            categoryRelModelList.push(JSON.parse(v[v.length - 1]));
          });
        }
        batchCondition.categoryRelModelList = categoryRelModelList;
        batchCondition.wxshopSpuIdList = this.checkedRow;
        let params = {};

        for (let key in batchCondition) {
          if (
            key !== "overstockSales" &&
            key !== "afterPayDays" &&
            key !== "couponUsable" &&
            key !== "recycleState"
          ) {
            params[key] = batchCondition[key];
          }
        }

        this.$store.dispatch("batchEditMicroShopGoods", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.queryList();
            this.dialogVisible = false;
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
          }
        });
      }
    },
    addGoods() {
      this.$router.push({ name: "AddMicroShopGoods" });
    },
    edit(row) {
      this.$router.push({
        name: "EditMicroShopGoods",
        query: {
          wxshopSpuId: row.wxshopSpuId,
        },
      });
    },
    filterFixed2(obj) {
      // prop = prop.replace(/^(0+)/, ""); //过滤0开头
      obj.value = obj.value.replace(/[^\d.]/g, ""); //仅保留数字和"."
      obj.value = obj.value.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      obj.value = obj.value
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      obj.value = obj.value.replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (obj.value.indexOf(".") < 0 && obj.value != "") {
        //首位是0的话去掉
        obj.value = parseFloat(obj.value);
      }
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed2() {
      //  this.memberGroupList[i][prop] =  this.memberGroupList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.batchPrice = this.batchPrice.replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.batchPrice = this.batchPrice.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.batchPrice = this.batchPrice
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.batchPrice = this.batchPrice.replace(/^(\d+)\.(\d\d).*$/, "$1.$2"); //限制只能输入两个小数
      if (this.batchPrice.indexOf(".") < 0 && this.batchPrice != "") {
        //首位是0的话去掉
        this.batchPrice = parseFloat(this.batchPrice);
      }
    },
    filterGroupFixed2(i, prop) {
      // this.memberGroupList[i][prop] = this.memberGroupList[i][prop].replace(
      //   /^(0+)/,
      //   ""
      // ); //过滤0开头
      this.memberGroupList[i][prop] = this.memberGroupList[i][prop].replace(
        /[^\d.]/g,
        ""
      ); //仅保留数字和"."
      this.memberGroupList[i][prop] = this.memberGroupList[i][prop].replace(
        /\.{2,}/g,
        "."
      ); //两个连续的"."仅保留第一个"."
      this.memberGroupList[i][prop] = this.memberGroupList[i][prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.memberGroupList[i][prop] = this.memberGroupList[i][prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (
        this.memberGroupList[i][prop].indexOf(".") < 0 &&
        this.memberGroupList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.memberGroupList[i][prop] = parseFloat(
          this.memberGroupList[i][prop]
        );
      }
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    remove(row, type) {
      this.$confirm(" 删除当前商品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let actionName = "deleteGoods";
        let params = {
          wxshopSpuIdList: row.wxshopSpuId,
        };
        if (type) {
          actionName = "batchEditMicroShopGoods";
          params = {
            wxshopSpuIdList: row,
            delFlag: 1,
          };
        }
        this.$store.dispatch(actionName, params).then((res) => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success",
            });
            this.queryList();
          }
        });
      });
    },
    switchAuditState(id, enabledState) {
      this.$store
        .dispatch("switchAuditState", {
          enabledState,
          id,
        })
        .then(() => {
          this.queryList();
        });
    },
    addActivity() {
      this.$router.push({
        name: "SelectActivity",
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    queryList(queryAll) {
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage,
        order: this.sort.order,
        prop: this.sort.prop,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;
      searchCondition.wxshopCategoryId = this.isArray(
        searchCondition.wxshopCategoryId
      )
        ? searchCondition.wxshopCategoryId[
            searchCondition.wxshopCategoryId.length - 1
          ]
        : searchCondition.wxshopCategoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
        ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
        : "";
      searchCondition.createStartTime = this.isArray(
        this.searchCondition.applyDate
      )
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.createEndTime = this.isArray(
        this.searchCondition.applyDate
      )
        ? searchCondition.applyDate[1]
        : "";
      Object.assign(params, searchCondition);
      if (!this.$route.query.wxshopCategoryId) {
        this.setParamsCookie();
      }
      const actionName = queryAll
        ? "queryAllMicroShopGoodsList"
        : "queryMicroShopGoodsList";
      return this.$store.dispatch(actionName, params);
    },
    getChecked(selection) {
      this.checkedRow = selection.map((v) => v.wxshopSpuId);
      this.wxshopSpuBos = selection;
      this.num = selection.length;
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
        this.$store.dispatch("queryMicroStoreList");
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    batchDelete() {
      if (this.checkedRow.length) {
        this.remove(this.checkedRow, "batch");
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
      this.drawer = false;
    },
    memberPrice(row) {
      this.dialogVisiblePrice = true;
      let params = {
        wxshopSpuId: row.wxshopSpuId,
      };
      this.spuId = row.wxshopSpuId;
      this.$store
        .dispatch("queryMicroGoodsDetails", { spuId: row.wxshopSpuId })
        .then((res) => {
          this.isSave = res.result.isSave;

          if (res.result.isSave == "yes") {
            this.$store
              .dispatch("queryMicroShopGoodsDetails", params)
              .then((res) => {
                res.result.skuModelListCopy.push({ specName: "网店售价" });

                if (res.result.skuModelList.length > 0) {
                  res.result.skuModelList.forEach((v) => {
                    v.specValueList.forEach((o, i) => {
                      v["specValue" + i] = o.specValue;
                    });
                  });
                } else {
                  res.result.skuModelList.push({
                    wxshopPrice: res.result.wxshopPrice,
                  });
                }

                this.ruleForm = res.result;
                this.$store
                  .dispatch("queryAllMemberGroupList", {
                    pageSize: 99999,
                    pageNo: 1,
                  })
                  .then((res) => {
                    res.result.records.forEach((x) => {
                      x.profitValue = "";
                    });
                    this.group = res.result.records;

                    this.ruleForm.skuModelList.forEach((v) => {
                      v.groupList = res.result.records;
                    });

                    // this.arr = [];
                    this.spuId = row.wxshopSpuId;
                    // res.result.records.map(v =>
                    //   this.arr.push({ groupId: v.groupId })
                    // );

                    // this.arr.forEach(o => {
                    //   o.storeSkuInfo = [];

                    //   this.ruleForm.skuModelList.map(v => {
                    //     o.storeSkuInfo.push({
                    //       profitValue: "",
                    //       groupId: o.groupId,
                    //       skuId: v.skuId
                    //     });
                    //   });
                    // });
                  });
              });
          } else {
            this.priceType = res.result.customPriceInfoVo.priceType;
            let listArry = [];
            listArry = res.result.customPriceInfoVo.storeSkuInfoVos;
            this.$store
              .dispatch("queryMicroShopGoodsDetails", params)
              .then((res) => {
                res.result.skuModelListCopy.push({ specName: "网店售价" });
                if (res.result.skuModelList.length > 0) {
                  res.result.skuModelList.forEach((v) => {
                    v.specValueList.forEach((o, i) => {
                      v["specValue" + i] = o.specValue;
                    });
                  });
                } else {
                  res.result.skuModelList.push({
                    wxshopPrice: res.result.wxshopPrice,
                  });
                }

                this.ruleForm = res.result;

                this.$store
                  .dispatch("queryAllMemberGroupList", {
                    pageSize: 99999,
                    pageNo: 1,
                  })
                  .then((res) => {
                    res.result.records.forEach((x) => {
                      x.profitValue = "";
                    });

                    this.group = res.result.records;

                    this.ruleForm.skuModelList.forEach((v) => {
                      v.groupList = res.result.records;
                    });

                    listArry.forEach((b) => {
                      b.skuPlatformCustomPriceInfoVos.forEach((z) => {
                        this.ruleForm.skuModelList.forEach((v) => {
                          v.groupList.forEach((x) => {
                            if (v.skuId) {
                              if (v.skuId + "&&&" + x.groupId == z.key) {
                                x[`${v.skuId}&&&${x.groupId}`] = z.profitValue;
                              }
                            } else {
                              if (
                                this.ruleForm.skuId + "&&&" + x.groupId ==
                                z.key
                              ) {
                                x[`${this.ruleForm.skuId}&&&${x.groupId}`] =
                                  z.profitValue;
                              }
                            }
                          });
                        });
                      });
                    });
                  });
              });
          }
        });
    },
    handleCheckAllChange(val) {
      this.checkedGoods = val ? this.result : [];
      this.isIndeterminate = false;
    },
    handleCheckedGoodsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.result.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.result.length;
    },
    affirm() {
      let skuList = this.ruleForm.skuModelList;
      let params = {};
      params.storeGroupPriceInfo = [];
      skuList.forEach((v) => {
        v.groupList.forEach(() => {
          params.storeGroupPriceInfo.push({});
        });
      });

      let flag = true;
      skuList.forEach((v) => {
        v.groupList.forEach((o) => {
          params.storeGroupPriceInfo.forEach((x) => {
            if (
              o[
                v.skuId
                  ? `${v.skuId}&&&${o.groupId}`
                  : `${this.ruleForm.skuId}&&&${o.groupId}`
              ] == "0"
            ) {
              flag = false;
            }
            if (this.priceType === "discount") {
              if (
                +o[
                  v.skuId
                    ? `${v.skuId}&&&${o.groupId}`
                    : `${this.ruleForm.skuId}&&&${o.groupId}`
                ] > 10
              ) {
                flag = false;
              }
            }
            if (
              o[
                v.skuId
                  ? `${v.skuId}&&&${o.groupId}`
                  : `${this.ruleForm.skuId}&&&${o.groupId}`
              ]
            ) {
              x[
                v.skuId
                  ? `${v.skuId}&&&${o.groupId}`
                  : `${this.ruleForm.skuId}&&&${o.groupId}`
              ] = (+o[
                v.skuId
                  ? `${v.skuId}&&&${o.groupId}`
                  : `${this.ruleForm.skuId}&&&${o.groupId}`
              ]).toFixed(2);
            } else {
              x[
                v.skuId
                  ? `${v.skuId}&&&${o.groupId}`
                  : `${this.ruleForm.skuId}&&&${o.groupId}`
              ] = "";
            }
          });
        });
      });
      params.storeGroupPriceInfo.splice(
        1,
        params.storeGroupPriceInfo.length - 1
      );
      // if(this.priceType==="discount"){
      //   params.storeGroupPriceInfo.forEach(v=>{
      //     if(){}
      //   })
      // }
      params.priceType = this.priceType;
      params.spuId = this.spuId;

      if (flag) {
        if (this.isSave == "yes") {
          this.$store.dispatch("addGroupPrice", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisiblePrice = false;
            }
          });
        } else if (this.isSave == "no") {
          this.$store.dispatch("editGroupPrice", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.dialogVisiblePrice = false;
            }
          });
        }
      } else {
        this.$message({
          type: "warning",
          message: "会员价不能为0,折扣不能大于10",
        });
      }
    },
    setParamsCookie() {
      setCookie({
        key: "microGoodsLibParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      // const prams = getCookie({ key: "microGoodsLibParams", type: "session" });
      // if (prams) {
      //   let search = {};
      //   for (let key in prams) {
      //     if (key !== "pageSize" && key !== "currentPage") {
      //       search[key] = prams[key];
      //     }
      //   }
      //   this.searchCondition = search;
      //   this.pageSize = prams.pageSize;
      //   this.currentPage = prams.currentPage;
      //   // this.searchCondition = prams;
      //   // this.pageSize = prams.pageSize;
      //   // this.currentPage = prams.currentPage;
      // }
    },
    async bathEditWxshopStockTips() {
      const { result } = await this.$store.dispatch("bathEditWxshopStockTips");
      this.tips = result.textContentZhCn.split("|");
    },
    addGoodsImg(type) {
      this.uploadType = type;
      switch (this.uploadType) {
        case "previewImgPath":
          this.imgWidth = 330;
          this.imgHeight = 330;
          break;
      }
      this.sellOutShowUploadImg = true;
    },
    handleRemovePrePic(type) {
      if (type === "previewImgPath") {
        this.sellOutRuleForm.previewImgPath = "";
      }
    },
    cropSuccess() {},
    cropUploadFail() {},
    async cropUploadSuccess(jsonData) {
      if (this.uploadType === "previewImgPath") {
        this.sellOutRuleForm.previewImgPath = jsonData.result;
      }
    },
    saveRuleForm(formName) {
      this.editStoreConfigSellOut();
    },
    async queryStoreConfigSellOut() {
      const { result } = await this.$store.dispatch("queryStoreConfigAll", {
        storeCode: this.storeCode,
        code: "sellOut",
      });
      console.log("result:", result);
      if (result.value) {
        this.sellOutRuleForm = JSON.parse(result.value);
        if (!this.sellOutRuleForm.sellOutGoodsState) {
          this.sellOutRuleForm.sellOutGoodsState = "open";
        }
        this.sellOutRuleForm = JSON.parse(JSON.stringify(this.sellOutRuleForm));
      } else {
        this.addStoreConfigSellOut();
      }
    },
    async addStoreConfigSellOut() {
      let value = JSON.stringify(this.sellOutRuleForm);
      const { result } = await this.$store.dispatch("addStoreConfigAll", {
        storeCode: this.storeCode,
        code: "sellOut",
        name: "新增售罄图标设置",
        value: value,
      });
      console.log("result:", result);
    },
    async editStoreConfigSellOut() {
      let value = JSON.stringify(this.sellOutRuleForm);
      const { result } = await this.$store.dispatch("editStoreConfigAll", {
        storeCode: this.storeCode,
        code: "sellOut",
        name: "编辑售罄图标设置",
        value: value,
      });
      this.$message({
        type: "success",
        message: "设置成功",
      });
      this.queryStoreConfigSellOut();
      this.sellOutSetdialogVisible = false;
    },
    closeRuleForm() {
      this.sellOutSetdialogVisible = false;
    },
    openRuleForm() {
      this.sellOutSetdialogVisible = true;
    },
  },
};
</script>
<style lang="scss">
.micro-goods-list {
  .el-tabs__header {
    background: #f4f4f4;
  }
}
.shop-list {
  .el-cascader {
    .el-input {
      width: 100%;
    }
  }
}
</style>
<style scoped lang="scss">
.member-price {
  height: 50px;
  line-height: 50px;
}
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.batch {
  div {
    margin: 20px 0;
    cursor: pointer;
    font-size: 14px;
    color: #222222;
    user-select: none;
    &:first-child {
      margin-right: 20px;
    }
  }
  .hmicon {
    margin-right: 5px;
  }
}

.table {
  .table-header {
    padding: 16px 0;
    background: #f7f7f7;
    font-size: 14px;
    font-weight: bold;
  }
  .table-row {
    padding: 16px 0;
    font-size: 14px;
  }
  .table-row:nth-child(odd) {
    background: #f7f7f7;
  }
  .add-wrapper,
  .minus-wrapper {
    margin: 0 auto;
  }
}

.tabs {
  .first-tip {
    padding-left: 30px;
    margin-bottom: 20px;
    .title {
      padding-left: 0;
    }
  }
  .title {
    color: #222222;
    padding-left: 10px;
  }
  .form-item-tip {
    font-size: 12px;
  }
}
.form-item-tip {
  color: #999;
  font-size: 14px;
}

.qrcode-wrapper {
  text-align: center;
  img {
    width: 200px;
    height: 200px;
  }
}
.priview {
  position: relative;
  width: 360px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.more-search {
  width: 10px;
  margin-right: 6px;
  transform: scale(0.9);
  color: #aaaaaa;
  box-shadow: -2px 2px 4px 0px rgba(0, 0, 0, 0.06);
  padding-left: 6px;
}
.bgColor {
  background: #fff;
}
.drawer-search {
  padding: 32px;
}
.tips {
  color: #e50065;
  padding-left: 100px;
}
.goods-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
        margin-right: 0 !important;
      }
    }
  }
}
.add-prize-img-wrapper {
  width: 20px;
  height: 20px;
  line-height: 20px;
  background: #e50065;
  color: #fff;
  text-align: center;
  border-radius: 50%;
  user-select: none;
  text-align: center;
  .hmicon {
    font-size: 14px;
    margin-right: 0px;
  }
}
.priviews {
  position: relative;
  width: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  margin: 0;
  padding: 0;
  .img {
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    // bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviews2 {
  width: 170px;
}
.tips-gray {
  color: #999999;
}
</style>
